"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const user_serializer_1 = require("../serializers/user.serializer");
const sdk_constants_1 = require("../constants/sdk.constants");
const roles_constants_1 = require("../constants/roles.constants");
const enums_1 = require("../enums");
class StudentClient {
    static newInstance(options, retryOptions) {
        return new StudentClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new user_serializer_1.UserSerializer());
    }
    constructor(client, serializer) {
        this.client = client;
        this.serializer = serializer;
    }
    findOne(studentId, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/${studentId}`, {
                headers,
            });
            const { 0: user } = response.body;
            user.role = roles_constants_1.STUDENT_ROLE;
            return this.serializer.serializeOne(user);
        });
    }
    findByIds(studentIds_1, headers_1) {
        return __awaiter(this, arguments, void 0, function* (studentIds, headers, isArchived = false, isDeleted = false, includeClasses = false) {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/${studentIds.join(',')}`, {
                params: { includeArchived: isArchived, isDeleted: isDeleted },
                headers,
            });
            if (includeClasses) {
                return this.serializeWithClassData(response.body);
            }
            return this.serialize(response.body);
        });
    }
    findByClass(classId_1, headers_1) {
        return __awaiter(this, arguments, void 0, function* (classId, headers, isArchived = false, pagination = enums_1.PaginationFlag.OFF) {
            let params = {
                class: classId,
                includeArchived: isArchived,
                pagination,
            };
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student`, {
                headers,
                params,
            });
            return pagination == enums_1.PaginationFlag.ON
                ? this.serialize(response.body.data)
                : this.serialize(response.body);
        });
    }
    listStudents(classId, headers, isArchived, pagination, skip, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                classId,
                includeArchived: isArchived,
                pagination,
                skip,
                limit,
            };
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/list`, {
                headers,
                params,
            });
            return this.serializeStudent(response.body.data);
        });
    }
    findOneV2(userId, params, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/v2/${userId}`, {
                params,
                headers,
            });
            return this.serialize(response.body);
        });
    }
    findManyV2(userId, params, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/v2/${userId.join(',')}`, {
                params,
                headers,
            });
            return this.serialize(response.body);
        });
    }
    serialize(users) {
        return users.map((user) => {
            user.role = roles_constants_1.STUDENT_ROLE;
            return this.serializer.serializeOne(user);
        });
    }
    serializeWithClassData(users) {
        return users.map((user) => {
            user.role = roles_constants_1.STUDENT_ROLE;
            return this.serializer.serializeOneWithClasses(user);
        });
    }
    serializeStudent(users) {
        return users.map((user) => {
            user.role = roles_constants_1.STUDENT_ROLE;
            return this.serializer.serializeOneStudentFromList(user);
        });
    }
}
exports.StudentClient = StudentClient;
//# sourceMappingURL=student.client.js.map